/* Nether: the capsule opens the buy steps as a sheet (2026-09-25, Roam for
   cold traffic). Owner: "a sheet to build in the sticky capsule would be cool",
   "where people can still do the bundle build and stuff in there".

   Phones only. When the sticky capsule is tapped while a step is still missing
   (no size yet, or the pack is not complete), the real buy blocks slide up in a
   sheet over the page instead of the page scrolling back to the top. They are
   MOVED, not copied, so the pack builder, Build Your Own, the size gate and the
   buy button keep every listener they had. They go back to their place in the
   buy column the moment the sheet closes, and a spacer holds their height so the
   page behind never jumps. With every step answered the capsule adds to cart
   exactly as it did before; this never touches that path.

   The sheet grows out of the capsule and folds back into it (owner, same day:
   "it doesn't animate out from the sticky capsule"). The capsule's box and
   radius are measured here and handed to the stylesheet as --sheet-from, the
   clip the sheet opens from and closes back to. See THE BUY SHEET in
   nether-pdp.css for the motion itself.

   The steps' own state lives on <html>: data-nether-needs-size (no size) and
   data-nether-mix-incomplete (the pack is short), both kept by nether-pdp and
   nether-pack-builder. That is the one question asked here. */
(() => {
  const PHONE = window.matchMedia('(max-width: 749px)');
  const STILL = window.matchMedia('(prefers-reduced-motion: reduce)');
  const root = document.documentElement;
  let sheet = null;
  let scrim = null;
  let holder = null;
  let moved = [];
  let lastFocus = null;
  let closing = false;

  /* The page behind holds still while the sheet is out (owner 2026-09-25: the
     sheet has to "get uncoupled from the page below"). Scrolling it by hand is
     already off (html overflow hidden, the scrim takes no touches), but code
     can still move it: a colour change used to scroll up to the gallery, and
     the step-follow scrolled the window. Those are stopped at their source
     (nether-gallery-progress.js, nether-pack-builder's follow()); this puts
     the page straight back if anything else ever tries. */
  let pinnedY = 0;
  const holdPage = () => {
    if (sheet && Math.abs(window.scrollY - pinnedY) > 0.5) window.scrollTo({ top: pinnedY, behavior: 'instant' });
  };

  const details = () => document.querySelector('.product-information .product-details');
  const needsStep = () => root.hasAttribute('data-nether-needs-size') || root.hasAttribute('data-nether-mix-incomplete');

  /* The run of blocks from the colour step to the buy button (and the express
     checkout right after it, when there is one), as the direct children of the
     buy column they are. */
  function stepBlocks() {
    const d = details();
    if (!d) return null;
    const colour = d.querySelector('.nether-colorway');
    const buy = d.querySelector('.buy-buttons-block');
    if (!colour || !buy) return null;
    const top = (el) => {
      let n = el;
      while (n.parentElement && !n.parentElement.classList.contains('group-block-content')) n = n.parentElement;
      return n;
    };
    const first = top(colour);
    const last = top(buy);
    if (!first.parentElement || first.parentElement !== last.parentElement) return null;
    const list = [];
    for (let n = first; n; n = n.nextElementSibling) {
      list.push(n);
      if (n === last) break;
    }
    const next = last.nextElementSibling;
    if (next && next.querySelector('shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .shopify-payment-button')) list.push(next);
    return list;
  }

  /* The capsule's box, as a clip on the sheet: inset from each of the sheet's
     edges, rounded like the pill. Measured fresh at every open and close. No
     capsule on screen means the sheet rises from the bottom edge instead. */
  function capsuleClip() {
    const bar = document.querySelector('.sticky-add-to-cart__bar');
    // The sheet where it rests, not where a finger has pulled it: a drag
    // leaves a translate on it, and measuring through that aimed the fold
    // the drag's distance above the capsule.
    const r = sheet.getBoundingClientRect();
    const t = getComputedStyle(sheet).transform;
    const pulled = t && t !== 'none' ? new DOMMatrixReadOnly(t).m42 : 0;
    const s = { top: r.top - pulled, bottom: r.bottom - pulled, left: r.left, right: r.right };
    const b = bar ? bar.getBoundingClientRect() : null;
    if (!b || !b.width || !b.height) return 'inset(100% 0 0 0 round 0px)';
    const px = (n) => Math.max(0, Math.round(n)) + 'px';
    const radius = Math.min(parseFloat(getComputedStyle(bar).borderTopLeftRadius) || b.height / 2, b.height / 2);
    return 'inset(' + px(b.top - s.top) + ' ' + px(s.right - b.right) + ' ' + px(s.bottom - b.bottom) + ' ' + px(b.left - s.left) + ' round ' + px(radius) + ')';
  }

  // How long a property's transition runs on an element right now, in ms.
  function transitionMs(el, prop) {
    const c = getComputedStyle(el);
    const props = c.transitionProperty.split(',').map((p) => p.trim());
    const durs = c.transitionDuration.split(',').map((d) => parseFloat(d) * (d.includes('ms') ? 1 : 1000));
    let i = props.indexOf(prop);
    if (i < 0) i = props.indexOf('all');
    return i < 0 ? 0 : durs[i % durs.length] || 0;
  }

  /* Horizon's sticky bar re-shows itself (data-stuck true) a frame after the
     buy button goes back above the screen. Hold the capsule where it is until
     it has, so it never dips out and back in; give up after 300ms and leave
     the bar to Horizon. */
  function settleCapsule(then) {
    const bar = document.querySelector('.sticky-add-to-cart__bar');
    if (!bar || bar.getAttribute('data-stuck') === 'true') {
      then();
      return;
    }
    let called = false;
    const finish = () => {
      if (called) return;
      called = true;
      watch.disconnect();
      then();
    };
    const watch = new MutationObserver(() => {
      if (bar.getAttribute('data-stuck') === 'true') finish();
    });
    watch.observe(bar, { attributes: true, attributeFilter: ['data-stuck'] });
    setTimeout(finish, 300);
  }

  function open() {
    if (sheet || closing || !PHONE.matches) return false;
    const blocks = stepBlocks();
    if (!blocks || !blocks.length) return false;
    const parent = blocks[0].parentElement;

    // Exactly the room the steps took, their outer margins included (the buy
    // button keeps 26px under it). A holder short by that margin shifted the
    // page 26px, the browser's scroll anchoring moved the scroll to match, and
    // the header read that as a scroll up and slid in behind the sheet.
    const firstBlock = blocks[0];
    const lastBlock = blocks[blocks.length - 1];
    const span =
      lastBlock.getBoundingClientRect().bottom + (parseFloat(getComputedStyle(lastBlock).marginBlockEnd) || 0) -
      (firstBlock.getBoundingClientRect().top - (parseFloat(getComputedStyle(firstBlock).marginBlockStart) || 0));
    holder = document.createElement('div');
    holder.className = 'nether-buy-sheet__holder';
    holder.style.blockSize = Math.max(0, span) + 'px';
    parent.insertBefore(holder, firstBlock);

    const title = (details().querySelector('h1') || {}).textContent;
    sheet = document.createElement('div');
    sheet.className = 'nether-buy-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-labelledby', 'nether-buy-sheet-title');
    sheet.tabIndex = -1;
    // No transition until the sheet is sitting on the capsule, or its first
    // clip would animate from nowhere.
    sheet.style.transition = 'none';
    sheet.innerHTML =
      '<div class="nether-buy-sheet__head">' +
      '<span class="nether-buy-sheet__grab" aria-hidden="true"></span>' +
      '<p class="nether-buy-sheet__title" id="nether-buy-sheet-title"></p>' +
      '<button type="button" class="nether-buy-sheet__close" aria-label="Close">' +
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
      '</button></div><div class="nether-buy-sheet__body"></div>';
    sheet.querySelector('.nether-buy-sheet__title').textContent = title ? title.trim() : '';
    const body = sheet.querySelector('.nether-buy-sheet__body');
    blocks.forEach((b) => body.appendChild(b));
    moved = blocks;
    parent.insertBefore(sheet, holder.nextSibling);

    scrim = document.createElement('div');
    scrim.className = 'nether-buy-sheet__scrim';
    parent.insertBefore(scrim, sheet);

    // Sit the sheet on the capsule (the capsule is still showing, so it
    // measures), then hide the capsule and let the clip open.
    sheet.style.setProperty('--sheet-from', capsuleClip());
    void sheet.offsetHeight;
    root.classList.add('nether-sheet-open');
    sheet.style.transition = '';
    void sheet.offsetHeight;
    root.classList.add('nether-sheet-shown');

    pinnedY = window.scrollY;
    window.addEventListener('scroll', holdPage, { passive: true });

    lastFocus = document.activeElement;
    sheet.focus({ preventScroll: true });

    scrim.addEventListener('click', () => close());
    sheet.querySelector('.nether-buy-sheet__close').addEventListener('click', () => close());
    dragToClose(sheet.querySelector('.nether-buy-sheet__head'));
    return true;
  }

  /* Folds the sheet back into the capsule. Every way out ends here, the drag
     included, and it matters that it does: the buy button has to be on screen
     (inside the folded sheet, over the capsule) right up to the moment it goes
     home, or Horizon never sees it leave and the capsule stays hidden. A sheet
     slid off the bottom takes the buy button off screen first, which is
     exactly that failure. */
  function close() {
    if (!sheet || closing) return;
    closing = true;
    let finished = false;
    const done = () => {
      if (finished) return;
      finished = true;
      window.removeEventListener('scroll', holdPage);
      moved.forEach((b) => holder.parentElement.insertBefore(b, holder));
      holder.remove();
      sheet.remove();
      scrim.remove();
      sheet = scrim = holder = null;
      moved = [];
      settleCapsule(() => {
        root.classList.remove('nether-sheet-open', 'nether-sheet-shown', 'nether-sheet-returning');
        closing = false;
      });
      if (lastFocus && lastFocus.isConnected) lastFocus.focus({ preventScroll: true });
    };
    if (STILL.matches) {
      done();
      return;
    }

    // The capsule is held in place while the sheet is out (see the stylesheet),
    // so this lands on it exactly. The transition is set here, inline, for
    // every way out: a drag leaves its own inline transition behind, and the
    // fold must not inherit it. transform is in the list for the drag, which
    // lets go wherever the finger left the sheet.
    sheet.style.setProperty('--sheet-from', capsuleClip());
    sheet.style.transition =
      'clip-path var(--motion-base) var(--ease-ui), transform var(--motion-base) var(--ease-ui), opacity var(--motion-instant) var(--ease-ui)';
    sheet.style.transform = '';
    root.classList.remove('nether-sheet-shown');
    const ms = transitionMs(sheet, 'clip-path') || 300;
    // Hand over to the capsule for the last 100ms, when the sheet is nearly
    // its shape, then take the sheet away.
    setTimeout(() => root.classList.add('nether-sheet-returning'), Math.max(0, ms - 100));
    setTimeout(done, ms + 20);
  }

  /* A downward drag on the sheet's head follows the finger. Past 80px it drops
     into the capsule, the drag carried on into the fold: the sheet settles
     back onto its seat while it folds, so its top edge keeps falling. Short
     of 80px it springs back. */
  function dragToClose(head) {
    let y0 = 0;
    let dy = 0;
    head.addEventListener('touchstart', (e) => {
      y0 = e.touches[0].clientY;
      dy = 0;
      sheet.style.transition = 'none';
    }, { passive: true });
    head.addEventListener('touchmove', (e) => {
      dy = e.touches[0].clientY - y0;
      // Down follows the finger. Up gives a little and resists (a quarter of
      // the pull, 24px at most), so the sheet reads as attached, not stuck.
      const shown = dy >= 0 ? dy : Math.max(-24, dy / 4);
      sheet.style.transform = 'translateY(' + shown + 'px)';
    }, { passive: true });
    head.addEventListener('touchend', () => {
      if (!sheet) return;
      if (dy > 80) {
        close();
        return;
      }
      sheet.style.transition = 'transform var(--motion-base) var(--ease-ui)';
      sheet.style.transform = '';
    });
  }

  /* The capsule. Capture phase, so this answers before the capsule's own
     handler, and only while a step is missing; otherwise the event passes
     straight through to the add-to-cart it always did. */
  document.addEventListener('click', (e) => {
    const btn = e.target instanceof Element ? e.target.closest('.sticky-add-to-cart__button') : null;
    if (!btn || !PHONE.matches || !needsStep()) return;
    if (!stepBlocks()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }, true);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && sheet) close();
  });
  /* Added to the cart from inside the sheet. nether-pdp's sequencer marks the
     add "done" on <html>, plays the check in the sheet's button, and opens the
     bag 950ms later when the add came from here (ATC_HOLD_SHEET_MS). The sheet
     folds back into the capsule at 450ms, once the check has drawn, so the
     check, the fold and the bag come one after another. */
  new MutationObserver(() => {
    if (!sheet || closing) return;
    const s = root.getAttribute('data-nether-atc');
    if (s === 'done' || s === 'resolved') setTimeout(() => close(), 450);
  }).observe(root, { attributes: true, attributeFilter: ['data-nether-atc'] });
  PHONE.addEventListener('change', () => { if (!PHONE.matches && sheet) close(); });
})();
